import { Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Sortable from './Sortable/sortable';
import TrendingTagsTable from './table';

const TrendingTagsList = () => {
  const [numberOfTrendingTags, setNumberOfTrendingTags] = useState(0);
  const [shouldUpdateUpper, setShouldUpdateUpper] = useState(false);
  const [shouldUpdateLower, setShouldUpdateLower] = useState(false);

  useEffect(() => {
    setShouldUpdateUpper(false);
  }, [shouldUpdateUpper]);

  useEffect(() => {
    setShouldUpdateLower(false);
  }, [shouldUpdateLower]);

  return (
    <div>
      <>
        <div className="content-header">
          <h1>Trending Tags</h1>
        </div>

        <div>
          <center>
            { numberOfTrendingTags >= 0
              ? (
                <Sortable
                  updateList={shouldUpdateUpper}
                  getNumberOfTrendingTags={setNumberOfTrendingTags}
                  updateLower={setShouldUpdateLower}
                />
              ) : (
                <Paper>
                  <p className="text-center">No Trending Tags Selected</p>
                </Paper>
              )}
          </center>

          <div style={{ marginTop: 100 }}>
            <center>
              <TrendingTagsTable
                maxTrendingTags={numberOfTrendingTags}
                updateUpper={setShouldUpdateUpper}
                updateList={shouldUpdateLower}
              />
            </center>
          </div>
        </div>
      </>
    </div>
  );
};
export default connect(null, { })(TrendingTagsList);
